<template>
    <div class="part7 part">
        <div class="top" :class="{animate: isAnimate}">
          <div class="title" :class="{animate: isAnimate}">安全保障</div>
        </div>
        <div class="bottom">
          <el-row>
            <el-col :span="6">
              <div class="pic pic1">
                <img :class="{animate: isAnimate}" src="../../static/images/xtaq.png" alt="">
              </div>
            </el-col>
            <el-col :span="6">
              <div class="pic pic2">
                <img :class="{animate: isAnimate}" src="../../static/images/csaq.png" alt="">
              </div>
            </el-col>
            <el-col :span="6">
              <div class="pic pic3">
                <img :class="{animate: isAnimate}" src="../../static/images/xxaq.png" alt="">
              </div>
            </el-col>
            <el-col :span="6">
              <div class="pic pic4">
                <img :class="{animate: isAnimate}" src="../../static/images/fwaq.png" alt="">
              </div>
            </el-col>
          </el-row>
        </div>
    </div>
</template>
<script>
export default {
    name :"Partseven",
    data(){
        return{
          isAnimate:false
        }
    },
    mounted:function(){
      document.addEventListener("scroll",this.actionAnima);
    },
    methods:{
      actionAnima:function(){
        let _self = this;
        const bodyH = document.body.scrollTop || document.documentElement.scrollTop;
        if(bodyH >= 4400){
          _self.isAnimate = true;
        }
      }
    }
}
</script>
<style scoped>
  .part7{
    background: #f4faf8;
    padding-top: 20px;
  }
  .part7 .top{
    height: 132px;
    line-height: 132px;
    width: 540px;
    margin: 60px auto 10px auto;
    background: url(../../static/images/security.png) no-repeat;
    background-size: 100% auto;
    background-position: center top;
    text-align: center;
    font-size: 40px;
    /* border: 1px solid red; */
  }
  .part7 .top.animate{
    animation: topBgDown 0.5s linear forwards;
  }
	.part7 .top .title{
		position: relative;
		opacity: 0;
	}
  .part7 .top .title.animate{
    animation: topUp 0.6s linear forwards;
  }
  .part7 .bottom{
    width: 1200px;
    height: 260px;
    padding: 80px 0 120px 0;
    margin: 0 auto !important;
    /* border: 1px solid red; */
  }
  .part7 .bottom .pic{
    height: 328;
    width: 288;
    overflow: hidden;
  }
  .part7 .bottom .pic img{
    width: 100%;
		position: relative;
  }
	.part7 .bottom .pic1 img{
		opacity: 0;
	}
  .part7 .bottom .pic1 img.animate{
    animation: bottomImgUp 0.4s linear forwards;
  }
	.part7 .bottom .pic2 img{
		opacity: 0;
	}
  .part7 .bottom .pic2 img.animate{
    animation: bottomImgUp 0.4s linear forwards;
		animation-delay: 0.2s;
  }
	.part7 .bottom .pic3 img{
		opacity: 0;
	}
  .part7 .bottom .pic3 img.animate{
    animation: bottomImgUp 0.4s linear forwards;
		animation-delay: 0.4s;
  }
	.part7 .bottom .pic4 img{
		opacity: 0;
	}
  .part7 .bottom .pic4 img.animate{
    animation: bottomImgUp 0.4s linear forwards;
		animation-delay: 0.6s;
  }
	@keyframes topUp{
		from{
				top: 15px;
				opacity: 0;
		}to{
				top: 0px;
				opacity: 1;
		}
  }
	@keyframes topBgDown{
		from{
			background-position: center top;
		}to{
			background-position: center center;
		}
  }
	@keyframes bottomImgUp{
		from{
				top: 15px;
				opacity: 0;
		}to{
				top: 0px;
				opacity: 1;
		}
  }
	@media (max-width: 1439px){
    .part7 p.center{
      width: 800px;
    }
    .part7 .bottom{
      width: 1000px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Partseven.vue